import { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../services/api';
import jwt_decode from 'jwt-decode';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const login = async (email, password) => {
    try {
      setError(null);
      const { data } = await authAPI.login({ email, password });
      localStorage.setItem('admin_token', data.token);
      setCurrentUser({
        id: data.id,
        email: data.email,
        role: data.role,
      });
      return data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to login');
      throw err;
    }
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    setCurrentUser(null);
  };

  const fetchUserProfile = async () => {
    try {
      const { data } = await authAPI.getProfile();
      setCurrentUser(data);
    } catch (err) {
      logout();
    }
  };

  // Check if token exists and is valid on initial load
  useEffect(() => {
    const checkAuth = async () => {
      setLoading(true);
      const token = localStorage.getItem('admin_token');
      
      if (token) {
        try {
          // Check if token is expired
          const decoded = jwt_decode(token);
          const currentTime = Date.now() / 1000;
          
          if (decoded.exp < currentTime) {
            logout();
          } else {
            await fetchUserProfile();
          }
        } catch (err) {
          logout();
        }
      }
      setLoading(false);
    };
    
    checkAuth();
  }, []);

  const value = {
    currentUser,
    login,
    logout,
    loading,
    error
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
